import UserNavInfo from '../UserNavInfo/UserNavInfo';
import Button from '../Button/Button';

const AppViewNav = ({showNavigation, redirect}) => {
return (
    <div>
        <Button displayText={"Back to DEFA.com"} buttonAction={() => redirect("https://defa.com")} /> 
        < UserNavInfo navigation={showNavigation} />
    </div>   
    )
}

export default AppViewNav;